import { FUNDRAISING_SETTINGS } from '../actions/fundraisings';

export const fundraisingSettingsReducer = (state = '', action) => {
  switch (action.type) {
    case FUNDRAISING_SETTINGS:
      return action.payload;
  }
  return state;
};
